// Centralized test IDs for consistent QA hooks
export const NAV = {
  root: "site-nav",
  logo: "nav-logo",
  link: (id) => `nav-link-${id}`,
  scheduleDemo: "nav-schedule-demo",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-section",
  headline: "hero-headline",
  scheduleDemo: "hero-schedule-demo-btn",
  talkExpert: "hero-talk-expert-btn",
};

export const CTA = {
  contactSubmit: "contact-submit-btn",
  newsletterInput: "newsletter-email-input",
  newsletterSubmit: "newsletter-submit-btn",
};

export const CONTACT = {
  name: "contact-name",
  company: "contact-company",
  email: "contact-email",
  phone: "contact-phone",
  requirements: "contact-requirements",
  submit: "contact-submit-btn",
};

export const CHAT = {
  toggle: "chatbot-toggle-btn",
  window: "chatbot-window",
  input: "chatbot-input",
  send: "chatbot-send-btn",
  close: "chatbot-close-btn",
  messages: "chatbot-messages",
};

export const WHATSAPP = {
  button: "whatsapp-float-btn",
};
